import axios from "axios";
import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Button, Card, CardBody, Input, FormGroup, Col, Row, Modal } from "reactstrap";

const PasswordResetView = () => {
  const { uid, token } = useParams();

  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  const buttonConfirmClick = () => {
    if (error) {
      setResponseMessage("");
      setError(false);
    } else {
      setResponseMessage("");
      navigate("/auth/login");
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setResponseMessage("Hasło oraz powtórzone hasło są różne!");
      setError(true);
      return;
    }

    const config = {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "post",
      url: `/api/users/reset_password_confirm/`,
      data: JSON.stringify({ uid, token, password }),
    };

    try {
      const response = await axios(config);
      setError(!(response?.status == 200));
      setResponseMessage(response.data);
    } catch (err) {
      setError(true);
      if (err?.response) {
        setResponseMessage(err.response.data);
      }
    }
  };

  return (
    <div className="content">
      <Row>
        <Col className="ml-auto mr-auto mt-5" md="7" style={{ maxWidth: "500px" }}>
          <Card>
            <CardBody>
              <div className="nav-tabs-navigation" style={{ borderBottom: "1px solid #17728d" }}>
                <div className="nav-tabs-wrapper">Zmiana hasła</div>
              </div>
              <div>
                <CardBody>
                  <Row>
                    <Row className="pb-2 mx-2">
                      <Col sm="1" md="1" className="m-auto">
                        <i className="nc-icon nc-alert-circle-i" />
                      </Col>
                      <Col sm="11" md="11" className="p-0">
                        <i>
                          Hasło powinno mieć co najmniej 8 znaków oraz zawierać wielką literę, cyfrę i&nbsp;znak
                          specjalny.
                        </i>
                      </Col>
                    </Row>
                    <br />
                    <br />

                    <Col sm="12" md="12">
                      <FormGroup>
                        <label htmlFor="password-field">{`${"Nowe hasło"}`}</label>
                        <Input
                          id="password-field"
                          className="border-input"
                          placeholder="nowe hasło"
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </FormGroup>
                      <FormGroup>
                        <label htmlFor="confirmPassword-field">Powtórz nowe hasło</label>
                        <Input
                          id="confirm-password-field"
                          className="border-input"
                          placeholder="powtórz hasło"
                          type="password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          style={
                            confirmPassword !== password && confirmPassword !== "" ? { borderColor: "#ed7d7d" } : {}
                          }
                          required
                        />
                      </FormGroup>
                    </Col>
                    <Col className="text-center">
                      <Button
                        className="btn-round"
                        color="aotmit"
                        outline
                        size="sm"
                        onClick={(e) => {
                          changePassword(e);
                        }}
                      >
                        Zmień hasło
                      </Button>
                    </Col>
                  </Row>
                </CardBody>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Modal className="modal-sm" modalClassName="modal-primary" isOpen={responseMessage && responseMessage.length}>
        <div className="modal-header justify-content-center">
          <div className="modal-profile ml-auto mr-auto">
            {error ? <i className="nc-icon nc-simple-remove" /> : <i className="nc-icon nc-check-2" />}
          </div>
        </div>
        <div className="modal-body">{responseMessage}</div>
        <div className="modal-footer">
          <Button color="link" data-dismiss="modal" type="button" onClick={buttonConfirmClick}>
            {error ? "Rozumiem" : "Nawiguj do strony logowania"}
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default PasswordResetView;
